import React, {useState} from 'react'
import './index.less'
import Icon from "../../../../components/Icon";
import CyLogoImage from '../../../../assets/images/cy/cy-logo.png'
import {Form, Input, Button, Checkbox, Row, Col} from 'antd';
//import { UserOutlined, LockOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';
import { URL_CHANGYAN_VCODE, URL_CY_OVERVIEW, URL_FORGET_PWD } from '../../../../constants/CyHomepage'
import {getLogin} from "../../../../request/CyHomepage";
import {URL_REGISTER_PC} from "../../../../constants/CyHomepage";
import {diffEndJump} from "../../../../utils/tools";

const clsPrefix = 'cy-login-modal'
const LoginModal: React.FC<{
  header?: string | React.ReactNode,
  visible: boolean,
  onClose: () => void,
  className?: string,
  headerStyle?: React.CSSProperties,
  style?: React.CSSProperties,
  wrapperStyle?: React.CSSProperties,
  contentStyle?: React.CSSProperties
}> = ({
  header,
  visible = true,
  onClose = () => null,
  className = '',
  headerStyle = {},
  style,
  children,
  wrapperStyle,
  contentStyle
}) => {

  // const [checked, setChecked] = React.useState({ normal: true, partialChecked: true });
  const [ vcodeSrc, setvcodeSrc ] = useState(URL_CHANGYAN_VCODE)
  function handleClose () {
    onClose()
  }

  function onFinish (values) {
    console.log('Received values of form: ', values);
    // @ts-ignore
    // 此地登录统计pc端登录成功数
    if (window && window.xqui && window.xqui.useStat) {
      // @ts-ignore
      window.xqui.useStat({
        category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_login`,
        page: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`,
        action: 'click',
        bizType: 5,
      })
    }

    getLogin(values).then(res => {
      if (!res) {
        return
      }
      if (res.code != 200) {
        alert(res.message)
        return
      }
      let data = res.data
      if(data.code == 0) {
        // 如果是移动端或者wap端，登录成功之后直接跳体验页面
        if (data.data && data.data.isVip) {
          handleClose()
          location.assign("/vip/overview");
        } else if (data.data && data.data.needBind) {
          // window.location= ctx +  "/setting/account-info";
          handleClose()
          location.assign("/setting/account-info");
        } else {
          // window.location= ctx +  "/overview";
          handleClose()
          location.assign(URL_CY_OVERVIEW);
        }
      } else if (data.code == 9) {
        console.log(4)
        //loginSelect(data.data, vcode, name);
      } else {
        changeVcode(null);
        alert(data.message)
      }
    }).catch((err) => {
      console.log(err, 'err')
    })
  }

  const formItemLayout = {
    labelCol: { span: 4, offset: 0.5 },
    wrapperCol: { offset: 0.5 },
  };

  // 目前不支持移动端的注册
  function handleRegister () {
    // @ts-ignore
    if (window && window.xqui && window.xqui.useStat) {
      // @ts-ignore
      window.xqui.useStat({
        category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_register`,
        page: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`,
        action: 'click',
        bizType:5,
      })
    }

    diffEndJump({
      href: URL_REGISTER_PC,
      isOpenNewWindow: false
    })
  }

  // function handleChecked(e) {
  //   console.log(e);
  //   setChecked({
  //     ...checked,
  //     [e.name]: e.checked,
  //   });
  // }

  function changeVcode(e) {
    console.log(e)
    new Date().getMilliseconds()
    let url = URL_CHANGYAN_VCODE + "?_" + new Date().getMilliseconds()
    setvcodeSrc(url)
  }


  return (
    <div className={`${clsPrefix} ${className} ${visible ? '' : `${clsPrefix}__invisible`}`} style={style}>
      <div className={`${clsPrefix}__mask`} onClick={handleClose} />
      <div className={`${clsPrefix}__wrapper`} style={wrapperStyle}>
        <div className={`${clsPrefix}__header`} style={headerStyle}>
          <img className={`${clsPrefix}__header__img`} src={CyLogoImage}></img>
          <div className={`${clsPrefix}__header__close-symbol`} onClick={handleClose}>
            <Icon name='raw-error' style={{ fontSize: '20px' }} />
          </div>
        </div>

        <div className={`${clsPrefix}__content`} style={contentStyle}>
          <Form
              {...formItemLayout}
              name="normal_login"
              className="login-form"
              initialValues={{ remember: true }}
              onFinish={onFinish}
          >
            <Form.Item
                name="name"
                rules={[{ required: true, message: '请输入用户名!' }]}
            >
              <Input
                  placeholder="手机号/电子邮件" />
            </Form.Item>
            <Form.Item
              //  label='密  码：'
                name="password"
                rules={[{ required: true, message: '请输入密码!' }]}
            >
              <Input
                  type="password"
                  placeholder="密码"
              />
            </Form.Item>
            <Form.Item
                name="vcode"
                rules={[{ required: true, message: '请输入验证码!' }]}
            >
              <Row gutter={8} className="vcode">
                <Col span={12}>
                  <Form.Item
                      name="vcode"
                      noStyle
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <img id="vcode-img" onClick={changeVcode} src={ vcodeSrc }/>
                </Col>
              </Row>
            </Form.Item>
            <Form.Item>
              <Form.Item name="rememberMe" valuePropName="checked" noStyle initialValue={true}>
                <Checkbox><span className="rememberMe">记住我</span></Checkbox>
              </Form.Item>

              <a className="login-form-forgot" href={URL_FORGET_PWD}>
                忘记密码？
              </a>
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" className="login-form-button">
                立即登录
              </Button>
            </Form.Item>
            <Form.Item>
            <Button type="default" htmlType="button" className="register-form-button" onClick={handleRegister}>
              马上注册
            </Button>
            </Form.Item>
            {/*<a onClick={handleRegister}>立即注册！</a>*/}
          </Form>
        </div>
      </div>
    </div>
  )
}


export  { LoginModal }
